import { useState } from "react";
import { CreateTemplate } from "../../../services/api/templates/CreateTemplate";

const ALLOWED_TYPES = [
  "Geral",
  "Avisos",
  "Faturas",
  "Suporte",
  "Marketing",
  "Outros",
];
const COPY_TYPES = ["copy_pix", "copy_digitable_line"];
const REGULAR_TYPES = ["quick_reply", "open_url"];

export function useTemplateConfig() {
  const [messages, setMessages] = useState([
    {
      id: "auto-reply",
      type: "text",
      content: "",
      fromMe: true,
      buttons: [],
    },
  ]);
  const [saving, setSaving] = useState(false);

  // ==========================
  // VALIDADORES
  // ==========================
  const areButtonsValid = (buttons = []) => {
    if (!Array.isArray(buttons)) return false;
    if (!buttons.length) return true;

    const hasCopyButtons = buttons.some((btn) => COPY_TYPES.includes(btn.type));
    const hasRegularButtons = buttons.some((btn) => REGULAR_TYPES.includes(btn.type));

    if (hasCopyButtons && hasRegularButtons) return false;

    return buttons.every((btn) => {
      if (!btn.type) return false;
      if (!btn.label?.trim()) return false;
      if (btn.type === "open_url" && !btn.url?.trim()) return false;
      return true;
    });
  };

  const areMessagesValid = () =>
    messages.filter((m) => m.fromMe).every((m) => areButtonsValid(m.buttons));

  // ==========================
  // PAYLOAD CANÔNICO (FRONT)
  // ==========================
  const buildPayload = (channelType) => ({
    messages: messages
      .filter((m) => m.fromMe)
      .map((m) => ({
        type: channelType === "email" ? "html" : m.type,
        content: m.content,
        ...(m.header?.type && m.header?.content && {
          header: {
            type: m.header.type,
            content: m.header.content,
          },
        }),
        ...(m.buttons?.length && {
          buttons: m.buttons.map((b) => ({
            type: b.type,
            label: b.label,
            ...(b.type === "open_url" && { url: b.url }),
          })),
        }),
      })),
  });

  const save = async (
    channelId,
    channelType,
    type = "Geral",
    name,
    emailSubject = "",
    emailSubtitle = "",
    emailAccentColor = "",
  ) => {
    if (!channelId || !channelType) {
      console.error("ChannelId ou channelType não informado");
      return false;
    }

    const normalizedType = ALLOWED_TYPES.includes(type) ? type : "Geral";

    if (channelType === "whatsapp_api" && !areMessagesValid()) {
      alert("Existem botões não configurados corretamente.");
      return false;
    }

    const payload = {
      channel_type: channelType,
      channel_id: channelId,
      message_tag: normalizedType,
      title: name,
      ...(channelType === "email" && emailSubject.trim() && {
        subject: emailSubject.trim(),
      }),
      ...(channelType === "email" && emailSubtitle.trim() && {
        email_subtitle: emailSubtitle.trim(),
      }),
      ...(channelType === "email" && emailAccentColor && {
        email_accent_color: emailAccentColor,
      }),
      messages: buildPayload(channelType).messages,
    };

    try {
      setSaving(true);
      const data = await CreateTemplate(payload);

      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error("❌ Erro ao criar template:", error);
      return {
        success: false,
        error,
      };
    } finally {
      setSaving(false);
    }
  };

  return {
    messages,
    setMessages,
    save,
    buildPayload,
    saving,
  };
}
